
  import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
/* Apply component specific CSS */
.accordion-title{
  font-family:var(--ff-display);
  font-size:var(--fs-4xl);
  line-height:var(--lh-4xl);
  color:var(--outline-soft-black);
}

.accordion-title.mobile{
  font-size:var(--fs-lg);
  line-height:var(--lh-lg);
  color:var(--outline-soft-black);
}

::slotted(outline-heading){
  margin-bottom:2.5rem;
}
`;